import {CONST} from '../../consts/consts';
import store from '../../store/store';
import domains from '../../res/domains/domains.json';


 function getSubDomain() {

    let domain = getDomainURI();
    let subDomain =  getSubDomainURI();
        // return '@agency';
    if (!subDomain && domains.MAIN_DOMAIN == domain) { // bimic
        return CONST.SUB_DOMAIN;
    } else  if (subDomain) { // sub domain
        return '@' + subDomain;
    } else if (!subDomain) { // park domain
        return domain;
    } else {
        console.warn('Error in read domain');
    }
}

function isMainDomain() {
    // return false;
    return getSubDomain() == CONST.SUB_DOMAIN;
}

function isMasterLayout() {
    const stored = store.getState();
    if (stored.agency.site_setting)
        return Boolean(stored.agency.site_setting.view.master_layout)
    return false;
}

function isBroker() {
    const stored = store.getState();
    if (stored.agency)
        return Boolean(stored.agency.is_broker)
    return false;
}

function isLifeAgency() {
    const stored = store.getState();
    if (stored.agency)
        return Boolean(stored.agency.is_life_agency)
    return false;
}

function isWebview() {
    const stored = store.getState();
    if (stored.agency.site_setting)
        return Boolean(store.getState().agency.site_setting.view.webview)
    return false;
}

function getDomainURI() {
    //return '192.168.1.12:3000';
    let domain = window.location.host.replace('www.', '').split('.').slice(-2).join('.')
    if (domain === 'localhost:3000'){
        domain = 'bimat.ir'
    }
    return domain;
}

function getDomainForSettingRequests() {
    //return '192.168.1.12:3000';
    let domain = window.location.host.replace('www.', '').split('.').slice(-3).join('.')

    if (domain === 'localhost:3000'){
        domain = 'bimic.ir'
    }
    return domain;
}

function getSubDomainURI() {
    if (window.location.host.replace('www.', '').split('.').length < 3)
        return false;
    return window.location.host.replace('www.', '').split('.').slice(-3, 1).join('.');
}

function getQueryParams() {
    const search = window.location.search.substring(1);
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export {
    getSubDomain,
    getDomainForSettingRequests,
    isMainDomain,
    isMasterLayout,
    isWebview,
    getDomainURI,
    getSubDomainURI,
    getQueryParams,
    isBroker,
    isLifeAgency
};









